export default "__VITE_ASSET__53771c0f__"